import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";

export default function SuccessRegistrationProcess() {
  const [program, setProgram] = useState("");

  useEffect(() => {
    const storedProgram = localStorage.getItem('successRegistrationProgram');
    if (storedProgram) {
      setProgram(storedProgram);
      localStorage.removeItem('successRegistrationProgram');
    }
  }, []);
  return (
    <div className="flex flex-col">
      <Alert
        className="mt-20 max-w-[500px] text-center mx-auto"
        variant="success"
      >
        You've successfully registered and enrolled for the new {program}{" "}
        experience. We are completing your profile setup. We will notify
        you once it's ready for you to login.
      </Alert>
    </div>
  );
}
